import { render, staticRenderFns } from "./rate-amount.vue?vue&type=template&id=01b4cee8&scoped=true&"
import script from "./rate-amount.vue?vue&type=script&lang=js&"
export * from "./rate-amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b4cee8",
  null
  
)

export default component.exports